export default __webpack_public_path__ + "static/media/Dates_Modifier.06b4786f.png";